import {MsgBox} from "../../cmpts/msg_box";
import styles from './taskpost.css'
import Modal from "../../cmpts/modal";
import Vars from "../../cmpts/system_vars";
import Util from "../../public/utils";
import {ModifyLink} from "./insertlink";
import {ModifyRank} from "./insertrank";
import {ModifySProgram} from "./insertsprogram";
import {ModifyFormLink} from "./insertformlink";
import Message from "../../common/message";

/**
 * 添加变量步骤
 * 1：命名变量
 * 2：命名变量_ITEM
 * 3：将变量添加到INSERT_ITEM_ID_MAP
 * 4：实现insertTextItem方法里该变量的实现
 * 5：实现transformDATA方法里该变量的匹配
 * @type {{}}
 */
let LastEditRangeArray = {};

let NICKNAME = 'NICKNAME';
// let GENDER = 'GENDER';
// let DATE = 'DATE';
let STOCKSURPLUS = 'STOCKSURPLUS';
let STOCKSURPLUS2 = 'STOCKSURPLUS2';
let STOCKSURPLUS3 = 'STOCKSURPLUS3';
let TIME = 'TIME';
let LINK = 'LINK';
let SPROGRAM = 'SPROGRAM';
let TOTAL_SUPPORT = 'TOTAL_SUPPORT';
let RANK = 'RANK';
let HELPVERIFYLINK = "HELPVERIFYLINK";
let FORMLINK = 'FORMLINK';
let FORMLINK2 = 'FORMLINK2';
let FORMLINK3 = 'FORMLINK3';
let REDEEMCODE_NOTTP = 'REDEEMCODE_NOTTP'
let REDEEMCODE = 'REDEEMCODE'
let REDEEMCODE2 = 'REDEEMCODE2'
let REDEEMCODE3 = 'REDEEMCODE3'
let EMOJI = 'EMOJI'
let WXW_ACCOUNT_NAME = 'WXW_ACCOUNT_NAME';
let ADD_TIME = 'ADD_TIME';
let GENDER = 'GENDER';
let INVITATION_CODE = 'INVITATION_CODE';
let COMPLETED_TASK_NUM = 'COMPLETED_TASK_NUM'; //已完成任务量
let UNCOMPLETED_TASK_NUM = 'UNCOMPLETED_TASK_NUM';//未完成任务量
let NICKNAME_ITEM = '<span class="tpmsgend"></span><span id="NICKNAME" class="insertItem" contenteditable="false">昵称</span><span class="tpmsgend"></span>';
// let GENDER_ITEM = '<span class="tpmsgend"></span><span id="GENDER" class="insertItem" contenteditable="false">好友性别</span><span class="tpmsgend"></span>';
// let DATE_ITEM = '<span class="tpmsgend"></span><span id="DATE" class="insertItem" contenteditable="false">添加时间</span><span class="tpmsgend"></span>';
let REDEEMCODE_NOTTP_ITEM = '<span class="tpmsgend"></span><span id="REDEEMCODE_NOTTP" class="insertItem" contenteditable="false">兑换码</span><span class="tpmsgend"></span>';
let REDEEMCODE_ITEM = '<span class="tpmsgend"></span><span id="REDEEMCODE" class="insertItem" contenteditable="false">一阶任务兑换码</span><span class="tpmsgend"></span>';
let REDEEMCODE_ITEM2 = '<span class="tpmsgend"></span><span id="REDEEMCODE2" class="insertItem" contenteditable="false">二阶任务兑换码</span><span class="tpmsgend"></span>';
let REDEEMCODE_ITEM3 = '<span class="tpmsgend"></span><span id="REDEEMCODE3" class="insertItem" contenteditable="false">三阶任务兑换码</span><span class="tpmsgend"></span>';
let INVITATION_CODE_ITEM = '<span class="tpmsgend"></span><span id="INVITATION_CODE" class="insertItem" contenteditable="false">邀请码</span><span class="tpmsgend"></span>';
let STOCKSURPLUS_ITEM = '<span class="tpmsgend"></span><span id="STOCKSURPLUS" class="insertItem" contenteditable="false">一阶任务剩余库存</span><span class="tpmsgend"></span>';
let STOCKSURPLUS_ITEM2 = '<span class="tpmsgend"></span><span id="STOCKSURPLUS2" class="insertItem" contenteditable="false">二阶任务剩余库存</span><span class="tpmsgend"></span>';
let STOCKSURPLUS_ITEM3 = '<span class="tpmsgend"></span><span id="STOCKSURPLUS3" class="insertItem" contenteditable="false">三阶任务剩余库存</span><span class="tpmsgend"></span>';
let TIME_ITEM = '<span class="tpmsgend"></span><span id="TIME" class="insertItem" contenteditable="false">时间</span><span class="tpmsgend"></span>';
let COMPLETED_TASK_NUM_ITEM = '<span classe="tpmsgend"></span><span id="COMPLETED_TASK_NUM" class="insertItem" contenteditable="false">已完成任务量</span><span class="tpmsgend"></span>';
let UNCOMPLETED_TASK_NUM_ITEM = '<span class="tpmsgend"></span><span id="UNCOMPLETED_TASK_NUM" class="insertItem" contenteditable="false">未完成任务量</span><span class="tpmsgend"></span>';
let TOTAL_SUPPORT_ITEM = '<span class="tpmsgend"></span><span id="TOTAL_SUPPORT" class="insertItem" contenteditable="false">累计获得支持人数</span><span class="tpmsgend"></span>';
let GOODS_NAME_ITEM = Vars.GOODS_NAME_ITEM();
let DATETIME_ITEM = Vars.DATETIME_ITEM();
let GOODS_AMOUNT_ITEM = Vars.GOODS_AMOUNT_ITEM();
let GROUP_NUM_ITEM = Vars.GROUP_NUM_ITEM();
let GROUP_LIMITEDTIME_ITEM = Vars.GROUP_LIMITEDTIME_ITEM();
let GROUP_ENDDATE_ITEM = Vars.GROUP_ENDDATE_ITEM();
let GROUP_BEGINDATE_ITEM = Vars.GROUP_BEGINDATE_ITEM();
let FROM_NICKNAME_ITEM = Vars.FROM_NICKNAME_ITEM();
let GROUP_PART_NUM_ITEM = Vars.GROUP_PART_NUM_ITEM();
let GROUP_CREATER_ITEM = Vars.GROUP_CREATER_ITEM();
let RETURN_AMOUNT_ITEM = Vars.RETURN_AMOUNT_ITEM();
let TALLIESDESC_ITEM = Vars.TALLIESDESC_ITEM();
let BOOST_NAME_ITEM = Vars.BOOST_NAME_ITEM();
let GIFTBAG_NAME_ITEM = Vars.GIFTBAG_NAME_ITEM();
let WXW_ACCOUNT_NAME_ITEM = Vars.WXW_ACCOUNT_NAME_ITEM();
let ADD_TIME_ITEM = Vars.ADD_TIME_ITEM();
let GENDER_ITEM = Vars.GENDER_ITEM();
let TEMPMXDWELL = 'TEMPMXDWELL';

let GOODS_NAME = 'GOODS_NAME';
let DATETIME = 'DATETIME';
let GOODS_AMOUNT = 'GOODS_AMOUNT';
let GROUP_NUM = 'GROUP_NUM';
let GROUP_LIMITEDTIME = 'GROUP_LIMITEDTIME';
let GROUP_ENDDATE = 'GROUP_ENDDATE';
let GROUP_BEGINDATE = 'GROUP_BEGINDATE';
let FROM_NICKNAME = 'FROM_NICKNAME';
let GROUP_PART_NUM = 'GROUP_PART_NUM';
let GROUP_CREATER = 'GROUP_CREATER';
let RETURN_AMOUNT = 'RETURN_AMOUNT';
let TALLIESDESC = 'TALLIESDESC';
let BOOST_NAME = 'BOOST_NAME';
let GIFTBAG_NAME = 'GIFTBAG_NAME';

let INSERT_ITEM_ID_MAP = {
    NICKNAME: true,
    // GENDER:true,
    // DATE : true,
    LINK: true,
    TOTAL_SUPPORT: true,
    COMPLETED_TASK_NUM: true,
    UNCOMPLETED_TASK_NUM: true,
    RANK: true,
    HELPVERIFYLINK: true,
    FORMLINK: true,
    FORMLINK2: true,
    FORMLINK3: true,
    STOCKSURPLUS: true,
    STOCKSURPLUS2: true,
    STOCKSURPLUS3: true,
    INVITATION_CODE: true,
    SPROGRAM: true,
    TIME: true,
    REDEEMCODE_NOTTP: true,
    REDEEMCODE: true,
    REDEEMCODE2: true,
    REDEEMCODE3: true,
    EMOJI: true,
    GOODS_NAME: true,
    DATETIME: true,
    GOODS_AMOUNT: true,
    GROUP_NUM: true,
    GROUP_LIMITEDTIME: true,
    GROUP_ENDDATE: true,
    GROUP_BEGINDATE: true,
    FROM_NICKNAME: true,
    GROUP_PART_NUM: true,
    GROUP_CREATER: true,
    RETURN_AMOUNT: true,
    BOOST_NAME: true,
    GIFTBAG_NAME: true,
    TALLIESDESC: true,
    WXW_ACCOUNT_NAME: true,
    ADD_TIME: true,
    GENDER: true
};

class TaskposterUtil {

    static checkMsgFormat(target) {
        var msgType = target.state.msgType;
        var noDisturb = target.state.noDisturb;
        var isDeductNOCT = target.state.isDeductNOCT;
        if (Util.isNull(msgType)) {
            msgType = 1;
            noDisturb = true;
        }
        var ids = ['genPosterMsg', 'newMemberJoinMsg', 'friendUnsubscribeMsg', 'repeatScanMsg', 'completeTaskMsg', 'completeTask2Msg', 'completeTask3Msg', 'nmactMsg', 'activityEndMsg', 'taskScheduleMsg'];
        if (msgType == 2) {
            ids = ['genPosterMsg', 'repeatScanMsg', 'nmactMsg', 'activityEndMsg', 'taskScheduleMsg'];
        }
        for (let m = 0; m < ids.length; m++) {
            if (ids[m] == 'completeTask2Msg' && $('#secondTask').hasClass('hide')) {
                continue;
            }
            if (ids[m] == 'completeTask3Msg' && $("#thirdTask").hasClass('hide')) {
                continue;
            }
            let nodes = document.querySelector('#' + ids[m]).childNodes;
            for (let i = 0; i < nodes.length; i++) {
                if (nodes[i].nodeType == 1) {
                    let id = nodes[i].getAttribute('id');
                    if (id == 'LINK') {
                        let h = nodes[i].getAttribute("href");
                        if (h == null || h.length == 0) {
                            MsgBox.showWarningMsg_4s('请输入链接“' + nodes[i].textContent + '”的地址');
                            return false;
                        }
                    }
                }
            }
        }
        if (msgType == 1 || (msgType == 2 && !noDisturb)) {
            var text = TaskposterUtil.transformOutMsg(document.querySelector("#taskScheduleMsg"));
            if (TaskposterUtil.isMsgEmpty(text)) {
                MsgBox.showWarningMsg_4s('请设置免打扰查看任务进度提醒');
                return false;
            }
        }
        if (msgType == 1) {
            var text = TaskposterUtil.transformOutMsg(document.querySelector("#newMemberJoinMsg"));
            if (TaskposterUtil.isMsgEmpty(text)) {
                MsgBox.showWarningMsg_4s('请设置新成员加入提醒');
                return false;
            }
            if (isDeductNOCT) {
                var text = TaskposterUtil.transformOutMsg(document.querySelector("#friendUnsubscribeMsg"));
                if (TaskposterUtil.isMsgEmpty(text)) {
                    MsgBox.showWarningMsg_4s('请设置好友取关扣除人气提醒');
                    return false;
                }
            }
            var text = TaskposterUtil.transformOutMsg(document.querySelector("#completeTaskMsg"));
            if (TaskposterUtil.isMsgEmpty(text)) {
                MsgBox.showWarningMsg_4s('请设置一阶任务完成提醒');
                return false;
            }
            if (!$("#secondTask").hasClass('hide')) {
                var text = TaskposterUtil.transformOutMsg(document.querySelector("#completeTask2Msg"));
                if (TaskposterUtil.isMsgEmpty(text)) {
                    MsgBox.showWarningMsg_4s('请设置二阶任务完成提醒');
                    return false;
                }
            }
            if (!$("#thirdTask").hasClass('hide')) {
                var text = TaskposterUtil.transformOutMsg(document.querySelector("#completeTask3Msg"));
                if (TaskposterUtil.isMsgEmpty(text)) {
                    MsgBox.showWarningMsg_4s('请设置三阶任务完成提醒');
                    return false;
                }
            }
        } else if (msgType == 2) {
            if (Util.isNull(target.form.newMemberJoinMsg)) {
                MsgBox.showWarningMsg_4s('请设置新成员加入提醒');
                return false;
            }
            if (isDeductNOCT && Util.isNull(target.form.friendUnsubsMsg)) {
                MsgBox.showWarningMsg_4s('请设置好友取关扣除人气提醒');
                return false;
            }
            if (Util.isNull(target.form.completeTaskMsg)) {
                MsgBox.showWarningMsg_4s('请设置一阶任务完成提醒');
                return false;
            }
            if (!$("#secondTask").hasClass('hide')) {
                if (Util.isNull(target.form.completeTask2Msg)) {
                    MsgBox.showWarningMsg_4s('请设置二阶任务完成提醒');
                    return false;
                }
            }
            if (!$("#thirdTask").hasClass('hide')) {
                if (Util.isNull(target.form.completeTask3Msg)) {
                    MsgBox.showWarningMsg_4s('请设置三阶任务完成提醒');
                    return false;
                }
            }
        }
        return true;
    }

    static isMsgEmpty(msg) {
        var re = /^\n*$/;
        return re.test(msg);
    }

    static checkGenPosterMsgFormat() {
        let nodes = document.querySelector('#genPosterMsg').childNodes;
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].nodeType == 1) {
                let id = nodes[i].getAttribute('id');
                if (id == 'LINK') {
                    let h = nodes[i].getAttribute("href");
                    if (h == null || h.length == 0) {
                        MsgBox.showWarningMsg_4s('请输入链接“' + nodes[i].textContent + '”的地址');
                        return false;
                    }
                }
            }
        }
        return true;
    }

    static getActivityTime(target) {
        var time = [];
        time.push(target.form.startTime);
        time.push(target.form.endTime);
        return time;
    }

    static initBeginTime(timeStr, target) {
        target.form.startTime = new Date(timeStr);
        $("#taskBeginDate").val(target.form.startTime.format('yyyy-MM-dd hh:mm'));
    }

    static initEndTime(timeStr, target) {
        target.form.endTime = new Date(timeStr);
        $("#taskEndDate").val(target.form.endTime.format('yyyy-MM-dd hh:mm'));
    }

    static transformOutMsg(ele) {
        let nodes = ele.childNodes;
        let text = '';

        for (var i = 0; i < nodes.length; i++) {
            if (nodes[i].nodeType == 1) {
                //ele
                let id = nodes[i].getAttribute('id');
                if (id && INSERT_ITEM_ID_MAP[id]) {
                    let re = new RegExp("#", "g");
                    if (id == LINK) {
                        let h = nodes[i].getAttribute("href");
                        if (h == null) {
                            h = '';
                        }
                        text = text + '<a href="' + h + '">' + nodes[i].textContent + '</a>'
                    } else if (id == RANK) {
                        let content = nodes[i].textContent.replace(re, TEMPMXDWELL);
                        text = text + '#' + id + '_' + content + '#';
                    } else if (id == HELPVERIFYLINK) {
                        let content = nodes[i].textContent.replace(re, TEMPMXDWELL);
                        text = text + '#' + id + '_' + content + '#';
                    } else if (id == FORMLINK || id == FORMLINK2 || id == FORMLINK3) {
                        let content = nodes[i].textContent.replace(re, TEMPMXDWELL);
                        text = text + '#' + id + '_' + content + '#';
                    } else if (id == SPROGRAM) {
                        var appid = nodes[i].getAttribute("data-miniprogram-appid");
                        if (appid == null) {
                            appid = '';
                        }
                        var path = nodes[i].getAttribute("data-miniprogram-path");
                        if (path == null) {
                            path = '';
                        }
                        text = text + '<a data-miniprogram-appid="' + appid + '" data-miniprogram-path="' + path + '">' + nodes[i].textContent + '</a>'
                    } else {
                        text = text + '#' + id + '#';
                    }
                } else if (nodes[i].nodeName.toLocaleLowerCase() == 'br') {
                    //换行
                    text = text + '\n';
                }
            } else if (nodes[i].nodeType == 3) {
                //text
                let id = nodes[i].parentNode.getAttribute('id');
                if (!(id && INSERT_ITEM_ID_MAP[id])) {
                    if (nodes[i].textContent.length > 0) {
                        text = text + nodes[i].textContent;
                    }
                }
            }
            text = text + TaskposterUtil.transformOutMsg(nodes[i]);
        }
        return text;
    }

    static transformInMsg(id, msg) {
        if (msg && msg.length > 0) {
            msg = TaskposterUtil.transformDATA(msg);
            let index = msg.indexOf('#RANK_');
            while (index != -1) {
                for (var i = index + 1; i < msg.length; i++) {
                    if (msg[i] == '#') {
                        let content = msg.substring(index + 6, i);
                        content = content.replace(re, "#");
                        let end = "";
                        if (i < msg.length - 1) {
                            end = msg.substring(i + 1);
                        }
                        msg = msg.substring(0, index) + '<span class="tpmsgend"></span><a id="RANK" class="cursor-pointer RANK" contenteditable="false">' + content + '</a><span class="tpmsgend"></span>' + end;
                        break;
                    }
                }
                index = msg.indexOf('#RANK_');
            }
            index = msg.indexOf('#FORMLINK_');
            while (index != -1) {
                for (var i = index + 1; i < msg.length; i++) {
                    if (msg[i] == '#') {
                        let content = msg.substring(index + 10, i);
                        content = content.replace(re, "#");
                        let end = "";
                        if (i < msg.length - 1) {
                            end = msg.substring(i + 1);
                        }
                        msg = msg.substring(0, index) + '<span class="tpmsgend"></span><a id="FORMLINK" class="cursor-pointer FORMLINK" contenteditable="false">' + content + '</a><span class="tpmsgend"></span>' + end;
                        break;
                    }
                }
                index = msg.indexOf('#FORMLINK_');
            }
            index = msg.indexOf('#FORMLINK2_');
            while (index != -1) {
                for (var i = index + 1; i < msg.length; i++) {
                    if (msg[i] == '#') {
                        let content = msg.substring(index + 11, i);
                        content = content.replace(re, "#");
                        let end = "";
                        if (i < msg.length - 1) {
                            end = msg.substring(i + 1);
                        }
                        msg = msg.substring(0, index) + '<span class="tpmsgend"></span><a id="FORMLINK2" class="cursor-pointer FORMLINK2" contenteditable="false">' + content + '</a><span class="tpmsgend"></span>' + end;
                        break;
                    }
                }
                index = msg.indexOf('#FORMLINK2_');
            }
            index = msg.indexOf('#FORMLINK3_');
            while (index != -1) {
                for (var i = index + 1; i < msg.length; i++) {
                    if (msg[i] == '#') {
                        let content = msg.substring(index + 11, i);
                        content = content.replace(re, "#");
                        let end = "";
                        if (i < msg.length - 1) {
                            end = msg.substring(i + 1);
                        }
                        msg = msg.substring(0, index) + '<span class="tpmsgend"></span><a id="FORMLINK3" class="cursor-pointer FORMLINK3" contenteditable="false">' + content + '</a><span class="tpmsgend"></span>' + end;
                        break;
                    }
                }
                index = msg.indexOf('#FORMLINK3_');
            }
            index = msg.indexOf('#HELPVERIFYLINK_');
            while (index != -1) {
                for (var i = index + 1; i < msg.length; i++) {
                    if (msg[i] == '#') {
                        let content = msg.substring(index + 16, i);
                        // content = content.replace(re, "#");
                        let end = "";
                        if (i < msg.length - 1) {
                            end = msg.substring(i + 1);
                        }
                        msg = msg.substring(0, index) + '<span class="tpmsgend"></span><a id="HELPVERIFYLINK" class="cursor-pointer HELPVERIFYLINK" contenteditable="false">' + content + '</a><span class="tpmsgend"></span>' + end;
                        break;
                    }
                }
                index = msg.indexOf('#HELPVERIFYLINK_');
            }

            let ele = document.querySelector("#" + id);
            ele.innerHTML = msg;
            let nodes = ele.childNodes;
            var link = [];
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].nodeType == 1 && nodes[i].nodeName.toLowerCase() == 'a') {
                    link.push(nodes[i]);
                    let id = nodes[i].getAttribute('id');
                    if (RANK != id && FORMLINK != id && FORMLINK2 != id && FORMLINK3 != id && HELPVERIFYLINK != id) {
                        if (nodes[i].hasAttribute('data-miniprogram-path') && nodes[i].hasAttribute('data-miniprogram-appid')) {
                            nodes[i].setAttribute("contenteditable", false);
                            nodes[i].setAttribute("id", SPROGRAM);
                            nodes[i].setAttribute("class", "cursor-pointer SPROGRAM");
                        } else {
                            nodes[i].setAttribute("contenteditable", false);
                            nodes[i].setAttribute("id", LINK);
                            nodes[i].setAttribute("class", "cursor-pointer LINK");
                            nodes[i].setAttribute("target", "_blank")
                        }
                    }
                }
            }
            for (var i = 0; i < link.length; i++) {
                var embed = document.createElement("span");
                embed.setAttribute('class', 'tpmsgend');
                var span = document.createElement('span');
                span.setAttribute('class', 'tpmsgend');
                ele.insertBefore(span, link[i]);
                ele.insertBefore(embed, link[i]);
                ele.removeChild(link[i]);
                ele.insertBefore(link[i], embed);
            }
        } else {
            let ele = document.querySelector("#" + id);
            ele.innerHTML = '';
        }
    }

    static checkPosterSetting(target) {
        var form = target.form;
        if (typeof form.poster == 'undefined' || form.poster == null) {
            MsgBox.showWarningMsg_4s('请上传海报');
            return false;
        }
        var genPosterKeyword = $("#genPosterKeyword").val();
        if (genPosterKeyword.length == 0) {
            MsgBox.showWarningMsg_4s('请输入海报生成关键词');
            return false;
        }
        if (genPosterKeyword.length > 10) {
            MsgBox.showWarningMsg_4s('海报生成关键词长度不要大于10');
            return false;
        }
        if ($("#genPosterMsg").html().length == 0) {
            MsgBox.showWarningMsg_4s('请输入生成海报消息提示');
            return false;
        }
        if (form.pushSharePoster) {
            var sharePosterMsg = TaskposterUtil.transformOutMsg(document.querySelector("#sharePosterMsg"));
            if (TaskposterUtil.isMsgEmpty(sharePosterMsg)) {
                MsgBox.showWarningMsg_4s('请输入海报分享话术');
                return false;
            }
        }
        form.genPosterKeyword = genPosterKeyword;
        return TaskposterUtil.checkGenPosterMsgFormat();
    }

    //适用于二阶 三阶任务完成提醒
    showCompleteTaskMsg(index, e) {
        var goal = Number($(e.target).val());
        if (index == 2) {
            //二阶
            if (goal <= 0) {
                if (!$("#secondTask").hasClass('hide')) {
                    $("#secondTask").addClass('hide');
                }
            } else {
                $("#secondTask").removeClass('hide');
            }
        } else if (index == 3) {
            //三阶
            if (goal <= 0) {
                if (!$("#thirdTask").hasClass('hide')) {
                    $("#thirdTask").addClass('hide');
                }
            } else {
                $("#thirdTask").removeClass('hide');
            }
        }
    }

    //适用于二阶 三阶任务完成提醒
    static showCompleteTaskMsg(index, e) {
        var goal = Number($(e.target).val());
        if (index == 2) {
            //二阶
            if (goal <= 0) {
                if (!$("#secondTask").hasClass('hide')) {
                    $("#secondTask").addClass('hide');
                }
            } else {
                $("#secondTask").removeClass('hide');
            }
        } else if (index == 3) {
            //三阶
            if (goal <= 0) {
                if (!$("#thirdTask").hasClass('hide')) {
                    $("#thirdTask").addClass('hide');
                }
            } else {
                $("#thirdTask").removeClass('hide');
            }
        }
    }

    static checkActivitySetting(target) {
        var form = target.form;
        var title = $("#activityTitle").val();
        if (title.length == 0) {
            MsgBox.showWarningMsg_4s('请输入活动标题');
            return false;
        }
        form.title = title;
        if (Util.isNull(form.startTime)) {
            MsgBox.showWarningMsg_4s('请选择活动开始时间');
            return false;
        }
        if (Util.isNull(form.endTime)) {
            MsgBox.showWarningMsg_4s('请选择活动结束时间');
            return false;
        }
        if (form.endTime <= form.startTime) {
            MsgBox.showWarningMsg_4s('活动结束时间必须晚于活动开始时间');
            return false;
        }
        if (form.endTime <= new Date()) {
            MsgBox.showWarningMsg_4s('活动结束时间必须晚于现在时间');
            return false;
        }
        var goal = Number($("#taskGoal").val());
        if (goal <= 0) {
            MsgBox.showWarningMsg_4s('一阶活动任务目标必须大于零');
            return false;
        }
        if (goal > 2147483647) {
            MsgBox.showWarningMsg_4s('一阶活动任务目标超出限制');
            return false;
        }
        var goal2 = Number($("#taskGoal2").val());
        var goal3 = Number($("#taskGoal3").val());
        if (goal2 < 0) {
            MsgBox.showWarningMsg_4s('二阶活动任务目标不能小于零');
            return false;
        }
        if (goal2 > 0 && goal2 <= goal) {
            MsgBox.showWarningMsg_4s('二阶活动任务目标必须大于一阶活动任务目标');
            return false;
        }
        if (goal2 > 2147483647) {
            MsgBox.showWarningMsg_4s('二阶活动任务目标超出限制');
            return false;
        }
        if (goal3 < 0) {
            MsgBox.showWarningMsg_4s('三阶活动任务目标不能小于零');
            return false;
        }
        if (goal3 > 0) {
            if (goal2 == 0) {
                MsgBox.showWarningMsg_4s('二阶活动任务目标必须大于零');
                return false;
            } else if (goal3 <= goal2) {
                MsgBox.showWarningMsg_4s('三阶活动任务目标必须大于二阶活动任务目标');
                return false;
            }
        }
        if (goal3 > 2147483647) {
            MsgBox.showWarningMsg_4s('三阶活动任务目标超出限制');
            return false;
        }
        let prizesStock = $("#prizesStock").val();
        if (prizesStock > 2147483647) {
            MsgBox.showWarningMsg_4s('一阶库存超出限制');
            return false;
        }

        form.goal = goal;
        form.goal2 = goal2;
        form.goal3 = goal3;
        var awardType = $("#awardType").val();
        if (awardType == 1) {
            var ID1 = $("#wxCardId1").val();
            var ID2 = $("#wxCardId2").val();
            var ID3 = $("#wxCardId3").val();
            if (ID1.length == 0 && ID2.length == 0 && ID3.length == 0) {
                MsgBox.showWarningMsg_4s('既然选了卡券奖励，至少填一个卡券ID吧');
                return false;
            }
        }
        return true;
    }

    static setLastEditRange(key, value) {
        LastEditRangeArray[key] = value;
    }

    static insertNickName(e) {
        TaskposterUtil.insertTextItem(NICKNAME, e);
    }

    // static insertGender(e){
    //     TaskposterUtil.insertTextItem(GENDER,e)
    // }
    // static insertDate(e){
    //     TaskposterUtil.insertTextItem(DATE,e)
    // }

    static insertGiftBagName(e) {
        TaskposterUtil.insertTextItem(GIFTBAG_NAME, e);
    }

    static insertBoostName(e) {
        TaskposterUtil.insertTextItem(BOOST_NAME, e);
    }

    static insertStockSurplus(e) {
        TaskposterUtil.insertTextItem(STOCKSURPLUS, e);
    }

    static insertStockSurplus2(e) {
        TaskposterUtil.insertTextItem(STOCKSURPLUS2, e);
    }

    static insertStockSurplus3(e) {
        TaskposterUtil.insertTextItem(STOCKSURPLUS3, e);
    }

    static insertTime(e) {
        TaskposterUtil.insertTextItem(TIME, e);
    }

    static insertLink(e) {
        TaskposterUtil.insertTextItem(LINK, e);
    }

    static insertSProgram(e) {
        TaskposterUtil.insertTextItem(SPROGRAM, e);
    }

    static insertInvitationCode(e) {
        TaskposterUtil.insertTextItem(INVITATION_CODE, e);
    }

    static insertRank(e) {
        TaskposterUtil.insertTextItem(RANK, e);
    }

    static insertHelpVerifyLink(e) {
        TaskposterUtil.insertTextItem(HELPVERIFYLINK, e);
    }

    static insertFormLink(e) {
        TaskposterUtil.insertTextItem(FORMLINK, e);
    }

    static insertFormLink2(e) {
        TaskposterUtil.insertTextItem(FORMLINK2, e);
    }

    static insertFormLink3(e) {
        TaskposterUtil.insertTextItem(FORMLINK3, e);
    }

    static insertFormCom(type, e) {
        TaskposterUtil.insertTextItem(type, e);
    }

    static insertEmoji(data, e) {
        if (data) {
            data = data.unified;
            let textArea = TaskposterUtil.getTextArea(e);
            console.log(textArea)
            let textAreaId = textArea.attr('id');
            let fromDataList = data.split('-').map(item => '0x' + item);
            let text = String.fromCodePoint(...fromDataList);
            TaskposterUtil.insertTextItem_(textAreaId, text, document.createTextNode(text));
        }
    }

    static insertRedeemcode(e) {
        TaskposterUtil.insertTextItem(REDEEMCODE, e);
    }


    static insertRedeemcodeNotTP(e) {
        TaskposterUtil.insertTextItem(REDEEMCODE_NOTTP, e);
    }

    static insertRedeemcode2(e) {
        TaskposterUtil.insertTextItem(REDEEMCODE2, e);
    }

    static insertRedeemcode3(e) {
        TaskposterUtil.insertTextItem(REDEEMCODE3, e);
    }

    static insertWxwAccountName(e) {
        TaskposterUtil.insertTextItem(WXW_ACCOUNT_NAME, e);
    }

    static insertAddTime(e) {
        TaskposterUtil.insertTextItem(ADD_TIME, e);
    }

    static insertGender(e) {
        TaskposterUtil.insertTextItem(GENDER, e);
    }

    static insertCompletedTaskNum(e) {
        TaskposterUtil.insertTextItem(COMPLETED_TASK_NUM, e);
    }

    static insertUncompletedTaskNum(e) {
        TaskposterUtil.insertTextItem(UNCOMPLETED_TASK_NUM, e);
    }

    static insertTotalSupport(e) {
        TaskposterUtil.insertTextItem(TOTAL_SUPPORT, e);
    }

    static getTextArea(e) {
        let parent = $(e.target).parent();
        let textArea = undefined;
        for (let i = 0; i < 100; i++) {
            if (parent) {
                textArea = parent.find('.rich-text-editor-content');
                if (textArea.length > 0) {
                    break;
                } else {
                    parent = parent.parent();
                }
            } else {
                break
            }
        }
        return textArea;
    }

    static insertTextItem(type, e) {
        let textArea = this.getTextArea(e);
        if (textArea) {
            var textAreaId = textArea.attr('id');
            if (type == NICKNAME) {
                var span = document.createElement("span");
                span.innerHTML = "昵称";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', NICKNAME);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, NICKNAME_ITEM, span);
            } else if (type == INVITATION_CODE) {
                var span = document.createElement("span");
                span.innerHTML = "邀请码";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', INVITATION_CODE);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, INVITATION_CODE_ITEM, span);
            } else if (type == STOCKSURPLUS) {
                //一阶剩余库存
                var span = document.createElement("span");
                span.innerHTML = "一阶剩余库存";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', STOCKSURPLUS);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, STOCKSURPLUS_ITEM, span);
            } else if (type == STOCKSURPLUS2) {
                //二阶剩余库存
                var span = document.createElement("span");
                span.innerHTML = "二阶剩余库存";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', STOCKSURPLUS2);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, STOCKSURPLUS_ITEM2, span);
            } else if (type == STOCKSURPLUS3) {
                //三阶剩余库存
                var span = document.createElement("span");
                span.innerHTML = "三阶剩余库存";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', STOCKSURPLUS3);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, STOCKSURPLUS_ITEM3, span);
            } else if (type == TIME) {
                var span = document.createElement("span");
                span.innerHTML = "时间";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', TIME);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, TIME_ITEM, span);
            } else if (type == LINK) {
                //插入链接
                $("#insertLink").attr('targetArea', textAreaId);
                Modal.show("#insertLink");
            } else if (type == SPROGRAM) {
                //插入链接
                $("#insertSProgram").attr('targetArea', textAreaId);
                Modal.show("#insertSProgram");
            } else if (type == COMPLETED_TASK_NUM) {
                var span = document.createElement("span");
                span.innerHTML = "已完成任务量";
                span.setAttribute('id', COMPLETED_TASK_NUM);
                span.setAttribute('class', 'insertItem');
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, COMPLETED_TASK_NUM_ITEM, span);
            } else if (type == UNCOMPLETED_TASK_NUM) {
                var span = document.createElement("span");
                span.innerHTML = "未完成任务量";
                span.setAttribute('id', UNCOMPLETED_TASK_NUM);
                span.setAttribute('class', 'insertItem');
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, UNCOMPLETED_TASK_NUM_ITEM, span);
            } else if (type == TOTAL_SUPPORT) {
                var span = document.createElement("span");
                span.innerHTML = "累计获得支持人数";
                span.setAttribute('id', TOTAL_SUPPORT);
                span.setAttribute('class', 'insertItem');
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, TOTAL_SUPPORT_ITEM, span);
            } else if (type == RANK) {
                $("#insertRank").attr('targetArea', textAreaId);
                Modal.show("#insertRank");
            } else if (type == HELPVERIFYLINK) {
                $("#insertHelpVerify").attr('targetArea', textAreaId);
                Modal.show("#insertHelpVerify");
            } else if (type == FORMLINK) {
                $("#insertFormLink").attr('targetArea', textAreaId);
                Modal.show("#insertFormLink");
            } else if (type == FORMLINK2) {
                $("#insertFormLink2").attr('targetArea', textAreaId);
                Modal.show("#insertFormLink2");
            } else if (type == FORMLINK3) {
                $("#insertFormLink3").attr('targetArea', textAreaId);
                Modal.show("#insertFormLink3");
            } else if (type == REDEEMCODE) {
                var span = document.createElement("span");
                span.innerHTML = "兑换码";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', REDEEMCODE);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, REDEEMCODE_ITEM, span);
            } else if (type == REDEEMCODE_NOTTP) {
                var span = document.createElement("span");
                span.innerHTML = "兑换码";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', REDEEMCODE_NOTTP);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, REDEEMCODE_NOTTP_ITEM, span);
            } else if (type == REDEEMCODE2) {
                var span = document.createElement("span");
                span.innerHTML = "兑换码";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', REDEEMCODE2);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, REDEEMCODE_ITEM2, span);
            } else if (type == REDEEMCODE3) {
                var span = document.createElement("span");
                span.innerHTML = "兑换码";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', REDEEMCODE3);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, REDEEMCODE_ITEM3, span);
            } else if (type == GOODS_NAME) {
                var span = document.createElement("span");
                span.innerHTML = "商品名称";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', GOODS_NAME);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, GOODS_NAME_ITEM, span);
            } else if (type == DATETIME) {
                var span = document.createElement("span");
                span.innerHTML = "当前时间";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', DATETIME);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, DATETIME_ITEM, span);
            } else if (type == GOODS_AMOUNT) {
                var span = document.createElement("span");
                span.innerHTML = "商品价格";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', GOODS_AMOUNT);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, GOODS_AMOUNT_ITEM, span);
            } else if (type == GROUP_NUM) {
                var span = document.createElement("span");
                span.innerHTML = "拼团人数";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', GROUP_NUM);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, GROUP_NUM_ITEM, span);
            } else if (type == GROUP_LIMITEDTIME) {
                var span = document.createElement("span");
                span.innerHTML = "拼团限制时间";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', GROUP_LIMITEDTIME);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, GROUP_LIMITEDTIME_ITEM, span);
            } else if (type == GROUP_ENDDATE) {
                var span = document.createElement("span");
                span.innerHTML = "拼团截止时间";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', GROUP_ENDDATE);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, GROUP_ENDDATE_ITEM, span);
            } else if (type == GROUP_BEGINDATE) {
                var span = document.createElement("span");
                span.innerHTML = "拼团开始时间";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', GROUP_BEGINDATE);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, GROUP_BEGINDATE_ITEM, span);
            } else if (type == FROM_NICKNAME) {
                var span = document.createElement("span");
                span.innerHTML = "好友昵称";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', FROM_NICKNAME);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, FROM_NICKNAME_ITEM, span);
            } else if (type == GROUP_PART_NUM) {
                var span = document.createElement("span");
                span.innerHTML = "已参团人数";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', GROUP_PART_NUM);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, GROUP_PART_NUM_ITEM, span);
            } else if (type == GROUP_CREATER) {
                var span = document.createElement("span");
                span.innerHTML = "团长昵称";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', GROUP_CREATER);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, GROUP_CREATER_ITEM, span);
            } else if (type == RETURN_AMOUNT) {
                var span = document.createElement("span");
                span.innerHTML = "返现金额";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', RETURN_AMOUNT);
                span.setAttribute('contenteditable', 'false');

                TaskposterUtil.insertTextItem_(textAreaId, RETURN_AMOUNT_ITEM, span);
            } else if (type == TALLIESDESC) {
                var span = document.createElement("span");
                span.innerHTML = "奖励金入账说明";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', TALLIESDESC);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, TALLIESDESC_ITEM, span);
            } else if (type == BOOST_NAME) {
                var span = document.createElement("span");
                span.innerHTML = "活动名称";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', BOOST_NAME);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, BOOST_NAME_ITEM, span);
            } else if (type == GIFTBAG_NAME) {
                var span = document.createElement("span");
                span.innerHTML = "活动名称";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', GIFTBAG_NAME);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, GIFTBAG_NAME_ITEM, span);
            } else if (type == WXW_ACCOUNT_NAME) {
                var span = document.createElement("span");
                span.innerHTML = "账号姓名";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', WXW_ACCOUNT_NAME);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, WXW_ACCOUNT_NAME_ITEM, span);
            } else if (type == ADD_TIME) {
                var span = document.createElement("span");
                span.innerHTML = "添加时间";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', ADD_TIME);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, ADD_TIME_ITEM, span);
            } else if (type == GENDER) {
                var span = document.createElement("span");
                span.innerHTML = "性别";
                span.setAttribute('class', 'insertItem');
                span.setAttribute('id', GENDER);
                span.setAttribute('contenteditable', 'false');
                TaskposterUtil.insertTextItem_(textAreaId, GENDER_ITEM, span);
            }
            // else if(type == GENDER){
            //     var span = document.createElement("span");
            //     span.innerHTML = "好友性别";
            //     span.setAttribute('class', 'insertItem');
            //     span.setAttribute('id', GENDER);
            //     span.setAttribute('contenteditable', 'false');
            //     TaskposterUtil.insertTextItem_(textAreaId, GENDER_ITEM, span);
            // }else if(type == DATE){
            //     var span = document.createElement("span");
            //     span.innerHTML = "添加时间";
            //     span.setAttribute('class', 'insertItem');
            //     span.setAttribute('id', DATE);
            //     span.setAttribute('contenteditable', 'false');
            //     TaskposterUtil.insertTextItem_(textAreaId, DATE_ITEM, span);
            // }
        }
    }

    static textAreaClick(e) {
        var selection = getSelection();
        // 设置最后光标对象
        TaskposterUtil.setLastEditRange(e.target.id, selection.getRangeAt(0))
    }

    static clearLastEditRange() {
        LastEditRangeArray = {};
    }

    static insertTextItem_(textAreaId, itemHtml, itemNode) {
        var lastEditRange = LastEditRangeArray[textAreaId];
        var textArea = $("#" + textAreaId);
        var text = textArea.html();
        text = text.replace(/&nbsp;/g, ' ');
        if (lastEditRange) {
            if (lastEditRange.startContainer.nodeName == '#text') {
                var data = lastEditRange.startContainer.data;
                var offset = lastEditRange.startOffset;
                if (offset == 0) {
                    let span = document.createElement('span');
                    span.setAttribute('class', 'tpmsgend');
                    lastEditRange.startContainer.parentNode.insertBefore(span, lastEditRange.startContainer);
                } else {
                    var n1 = document.createTextNode(data.substring(0, offset));
                    lastEditRange.startContainer.parentNode.insertBefore(n1, lastEditRange.startContainer);
                }
                lastEditRange.startContainer.parentNode.insertBefore(itemNode, lastEditRange.startContainer);
                let span = document.createElement('span');
                span.setAttribute('class', 'tpmsgend');
                lastEditRange.startContainer.parentNode.insertBefore(span, lastEditRange.startContainer);
                var n3 = document.createTextNode(data.substring(offset, data.length));
                lastEditRange.startContainer.parentNode.insertBefore(n3, lastEditRange.startContainer);
                lastEditRange.startContainer.parentNode.removeChild(lastEditRange.startContainer);
                TaskposterUtil.checkArea(textAreaId);
                return;
            } else {
                if (lastEditRange.startContainer.className.indexOf('rich-text-editor-content') != -1) {
                    let span = document.createElement('span');
                    span.setAttribute('class', 'tpmsgend');
                    lastEditRange.startContainer.appendChild(span);
                    lastEditRange.startContainer.appendChild(itemNode);
                    let source = document.createElement('span');
                    source.setAttribute('class', 'tpmsgend');
                    lastEditRange.startContainer.appendChild(source);
                } else if (lastEditRange.startContainer.className == 'tpmsgend') {
                    let span = document.createElement('span');
                    span.setAttribute('class', 'tpmsgend');
                    lastEditRange.startContainer.parentNode.insertBefore(span, lastEditRange.startContainer);
                    lastEditRange.startContainer.parentNode.insertBefore(itemNode, lastEditRange.startContainer);
                } else {
                    lastEditRange.startContainer.parentNode.insertBefore(itemNode, lastEditRange.startContainer);
                }
                TaskposterUtil.checkArea(textAreaId);
                return;
            }
        } else {
            text = text + itemHtml;
            textArea.html(text);
            TaskposterUtil.checkArea(textAreaId);
        }
        ModifyLink.initLINKEvent();
        ModifyRank.initRankEvent();
        ModifySProgram.initSProgramEvent();
        ModifyFormLink.initFormLinkEvent();
    }

    static checkArea(textAreaId) {
        let msg = TaskposterUtil.transformOutMsg(document.getElementById(textAreaId));
        TaskposterUtil.transformInMsg(textAreaId, msg);
    }

    static showTaskScheduleMsg(goal) {
        if (this.isHighGoal(goal)) {
            $("#taskSchedule").removeClass('hide')
        } else {
            $("#taskSchedule").addClass('hide')
        }
    }

    static isHighGoal(goal) {
        if (goal > 0) {
            return true;
        } else {
            return false;
        }
    }

    static getAwardContent(awardType) {
        var content = "";
        if (awardType == 1) {
            //卡券模式
            content = {
                ID1: $("#wxCardId1").val(),
                ID2: $("#wxCardId2").val(),
                ID3: $("#wxCardId3").val(),
            }
        }
        return content;
    }

    static setAwardContent(awardType, content, target) {
        target.form.awardType = awardType;
        target.setState({
            awardType: awardType
        });
        if (awardType == 1) {
            $("#wxCardId1").val(content.ID1);
            $("#wxCardId2").val(content.ID2);
            $("#wxCardId3").val(content.ID3);
        }
    }

    static inputWordChange(limit, e) {
        var v = e.target.value;
        if (v.length > limit) {
            e.target.value = v.substring(0, limit);
            $(e.target).siblings('.' + styles.wordLimit).html(limit + "/" + limit)
        } else {
            $(e.target).siblings('.' + styles.wordLimit).html(v.length + "/" + limit)
        }
    }

    static getWordPicMsgExample() {
        return '哎哟，不错哦~来的刚刚好！TEMP_MXD_ENTER这里有一份超级赞的活动想分享给你TEMP_MXD_ENTER将下面这张【专属海报】分享到朋友圈TEMP_MXD_ENTER获得3个好友支持后，将获得我们什么大奖TEMP_MXD_ENTER↓↓邀请卡正在生成中↓↓';
    }

    static getGenPosterMsgExample() {
        return '@#NICKNAME#您好！欢迎关注媒想到吧！TEMP_MXD_ENTER本活动是xxxTEMP_MXD_ENTERTEMP_MXD_ENTER如何免费领取奖品？TEMP_MXD_ENTER将下方的海报分享给你的好友，TEMP_MXD_ENTER并成功拉取3名好友扫码关注TEMP_MXD_ENTER公众号，即可完成任务。TEMP_MXD_ENTERTEMP_MXD_ENTER#RANK_戳此查看助力排行榜#';
    }

    static getGenQrcodeMsg() {
        return '@#NICKNAME#，TEMP_MXD_ENTER您正在为好友助力！TEMP_MXD_ENTER添加下方老师微信，即可助力成功。TEMP_MXD_ENTER非常感谢你的帮助！TEMP_MXD_ENTER添加后你也能一起参与领取100支笔芯！TEMP_MXD_ENTER奖品仅限500份，先到先得！TEMP_MXD_ENTER↓↓↓'
    }

    // 引导分享活动话术
    static getGenPosterMsgExampleNew() {
        return '@#NICKNAME#您好！欢迎关注xxx！TEMP_MXD_ENTER本次活动是xxx。TEMP_MXD_ENTER如何免费领取奖品？TEMP_MXD_ENTER将下方个人专属海报分享至朋友圈或微信好友，TEMP_MXD_ENTER成功邀请3名好友扫码助力，TEMP_MXD_ENTER即可完成任务获得xxx奖品。';
    }

    // 引导添加企业微信好友话术
    static getGenQrcodeMsgNew() {
        return '@#NICKNAME#您好！欢迎关注xxx！TEMP_MXD_ENTER本次活动是xxx。TEMP_MXD_ENTER如何免费领取奖品？TEMP_MXD_ENTER将下方个人专属海报分享至朋友圈或微信好友，TEMP_MXD_ENTER成功邀请3名好友扫码助力，TEMP_MXD_ENTER即可完成任务获得xxx奖品。';
    }

    // 新成员加入提醒
    static getCorpNewMemberJoinMsgVars() {
        return '您好！您的好友#NICKNAME#支持你了！TEMP_MXD_ENTER你已获得#COMPLETED_TASK_NUM#个好友的支持，TEMP_MXD_ENTER还差#UNCOMPLETED_TASK_NUM#个好友支持，即可获得奖励。TEMP_MXD_ENTER继续努力邀请吧~'
    }

    // 好友取关扣除人气提醒
    static getCorpFriendUnsubscribeMsgExample() {
        return "您的好友#NICKNAME#放弃为你助力！TEMP_MXD_ENTER人气值-1，还差#UNCOMPLETED_TASK_NUM#个好友的支持。TEMP_MXD_ENTER继续努力邀请吧~";
    }

    // 任务完成提醒
    static getCorpCompleteTaskMsgExample() {
        return '您好！您的好友#NICKNAME#支持你了！TEMP_MXD_ENTER您已获得#COMPLETED_TASK_NUM#个好友的支持TEMP_MXD_ENTER恭喜您完成任务！TEMP_MXD_ENTERTEMP_MXD_ENTER点此领取奖品吧~'
    }

    // 提示邀请者让好友添加企业微信好友提醒
    static getCorpHelpFailMsgExample() {
        return '您的好友@#NICKNAME#还未为您助力，只有加老师的企业微信后才算助力成功哦~TEMP_MXD_ENTER快提醒他吧~'
    }

    // 免打扰查看任务进度提醒
    static getCorpTaskScheduleMsgExample() {
        return '为了不频繁的打扰您，今天的活动进度就暂时为您汇报到这里了TEMP_MXD_ENTERTEMP_MXD_ENTER任务完成时，您会收到任务完成通知TEMP_MXD_ENTER#RANK_戳此查看最新任务进度#TEMP_MXD_ENTERTEMP_MXD_ENTER回复关键词【继续】，可继续接收任务进度通知';
    }

    // 重复参与提醒
    static getCorpRepeatScanMsgExample() {
        return '您已经参加了本次活动，快去把海报分享给好友吧TEMP_MXD_ENTER';
    }

    // 活动完成后继续有新成员加入提醒
    static getCorpNmactMsgExample() {
        return '任务已完成！您的好友#NICKNAME#又支持你了！人气值+1TEMP_MXD_ENTER目前已有#COMPLETED_TASK_NUM#人支持你！'
    }

    // 活动结束提醒
    static getCorpActivityEndMsgExample() {
        return '本次活动已结束，更多精彩活动敬请关注'
    }

    static getGenPosterMsgVarsNew() {
        return [Vars.NICKNAME(), Vars.LINK(), Vars.SPROGRAM(), Vars.RANK(), Vars.STOCKSURPLUS(), Vars.STOCKSURPLUS2(), Vars.STOCKSURPLUS3()];
    }

    static getGenQrcodeMsgVarsNew() {
        return [Vars.NICKNAME(), Vars.LINK()];
    }

    static getGenPosterMsgVars() {
        return [Vars.NICKNAME(), Vars.LINK(), Vars.RANK(), Vars.SPROGRAM(), Vars.STOCKSURPLUS(), Vars.STOCKSURPLUS2(), Vars.STOCKSURPLUS3(),];
    }

    static getSharePosterMsgVars(inviteType) {
        if (inviteType == 2) {
            return [Vars.INVITATION_CODE(), Vars.NICKNAME(), Vars.LINK(), Vars.RANK(), Vars.SPROGRAM(), Vars.STOCKSURPLUS(), Vars.STOCKSURPLUS2(), Vars.STOCKSURPLUS3()];
        } else {
            return [Vars.NICKNAME(), Vars.LINK(), Vars.RANK(), Vars.SPROGRAM(), Vars.STOCKSURPLUS(), Vars.STOCKSURPLUS2(), Vars.STOCKSURPLUS3()];
        }
    }

    static getSharePosterMsgNewsVars(inviteType) {
        if (inviteType == 2) {
            return [Vars.INVITATION_CODE(), Vars.NICKNAME(), Vars.STOCKSURPLUS(), Vars.STOCKSURPLUS2(), Vars.STOCKSURPLUS3()];
        } else {
            return [Vars.NICKNAME(), Vars.STOCKSURPLUS(), Vars.STOCKSURPLUS2(), Vars.STOCKSURPLUS3()];
        }
    }

    static getGenPosterMsgVarsWithForm() {
        return [Vars.NICKNAME(), Vars.STOCKSURPLUS(), Vars.LINK(), Vars.RANK(), Vars.SPROGRAM(), Vars.FORM_LINK()];
    }

    static getPicWordVars() {
        return [Vars.NICKNAME(), Vars.LINK(), Vars.SPROGRAM()];
    }

    static getTaskPosterPicWordVars() {
        return [Vars.NICKNAME(), Vars.LINK(), Vars.SPROGRAM(), Vars.STOCKSURPLUS(), Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM(), Vars.FORM_LINK_SELECT(), Vars.RANK()];
    }

    static getWordPicVars() {
        return [Vars.NICKNAME()];
    }

    static getTaskPosterWordPicVars() {
        return [Vars.NICKNAME(), Vars.STOCKSURPLUS(), Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM()];
    }


    static getSharePosterMsgExample() {
        return '我参加了一个超赞的活动TEMP_MXD_ENTER求扫码支持!TEMP_MXD_ENTERTEMP_MXD_ENTER你的支持就是我最大的动力，这次拜托大家了！TEMP_MXD_ENTER';
    }

    static getNewMemberJoinMsgExample() {
        return "您好！您的好友#NICKNAME#支持你了！TEMP_MXD_ENTER你已获得#COMPLETED_TASK_NUM#个好友的支持TEMP_MXD_ENTER还差#UNCOMPLETED_TASK_NUM#个好友支持，即可获得奖励";
    }

    static getNewMemberJoinMsgVars() {
        return [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.STOCKSURPLUS(),Vars.TIME()];
    }
    static newGetNewMemberJoinMsgVars() {
        return [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM(), Vars.SPROGRAM(),Vars.TIME()];
    }

    static getRedpacketAddFriendsMsgVars() {
        return [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME()];
    }

    static getRedpacketDelFriendsMsgVars() {
        return [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME()];
    }

    static getRedpacketReceoiptMsgVars() {
        return [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME()]
    }

    static getLotteryAddFriendsMsgVars() {
        return [Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME()];
    }

    static getLotteryDelFriendsMsgVars() {
        return [Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME()];
    }

    static getLotteryCompletedMsgVars() {
        return [Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME()];
    }

    static getCreateTemplateVars() {
        return [Vars.NICKNAME(), Vars.TIME()];
    }


    static getFriendUnsubscribeMsgExample() {
        return "您的好友#NICKNAME#放弃为你助力！TEMP_MXD_ENTER人气值-1，还差#UNCOMPLETED_TASK_NUM#个好友的支持。";
    }

    static getFriendUnsubscribeMsgVars() {
        return [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM(),Vars.STOCKSURPLUS(), Vars.SPROGRAM(), Vars.TIME()];
    }
    //客户裂变增强活动
    static customerEnhanceActivity(){
        return [Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(),Vars.UNCOMPLETED_TASK_NUM(), Vars.STOCKSURPLUS(), Vars.TIME(), Vars.EMOJI()]
    }
    static newCustomerEnhanceActivity(){
        return [Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.STOCKSURPLUS(), Vars.TIME(), Vars.EMOJI()]
    }
    //抽奖裂变增强活动
    static lotteryEnhanceActivity(){
        return [Vars.NICKNAME(), Vars.FROM_NICKNAME(),Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM(),Vars.TIME(), Vars.EMOJI()]
    }
    static newLotteryEnhanceActivity(){
        return [Vars.NICKNAME(), Vars.FROM_NICKNAME(),Vars.COMPLETED_TASK_NUM(),Vars.TIME(), Vars.EMOJI()]
    }

    static getHelpVerifyMsgVars() {
        return [Vars.NICKNAME(), Vars.HELP_VERIFY_LINK()]
    }

    static getHelpVerifyMsgExample() {
        return "@#NICKNAME#您好！您正在为您的好友助力，请点击下方链接完成认证，方可助力成功。TEMP_MXD_ENTER#HELPVERIFYLINK_点击进行认证#";
    }

    static getNewCustomerFission() {
        return "@#NICKNAME#您好！您正在为您的好友助力，请点击下方链接完成认证，方可助力成功。";
    }

    static getJoinInBlacklistMsgExample() {
        return "@#NICKNAME#您好！您被系统判定为恶意刷单被加入到黑名单中，将无法继续参加该公众号的任何活动，如有疑问，请联系客服微信xxx。";
    }

    static getJoinInBlacklistMsgVars() {
        return [Vars.LINK(), Vars.NICKNAME(), Vars.SPROGRAM()];
    }

    static getTaskScheduleMsgExample() {
        return '为了不频繁的打扰您，今天的活TEMP_MXD_ENTER动进度就暂时为您汇报到这里了TEMP_MXD_ENTERTEMP_MXD_ENTER任务完成时，您会收到任务完成通知TEMP_MXD_ENTER#RANK_戳此查看最新任务进度#TEMP_MXD_ENTERTEMP_MXD_ENTER回复关键词【继续】，可继续接收任务进度通知';
    }

    static getTaskScheduleMsgVars() {
        return [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.UNCOMPLETED_TASK_NUM(), Vars.SPROGRAM()];
    }

    //群裂变新建活动获取昵称
    static getObtainANickname() {
        return [Vars.NICKNAME(), Vars.EMOJI()];
    }

    static getNewWelcomeSpeech() {
        return [Vars.NICKNAME(), Vars.EMOJI()]
    }

    //紫鲲云手机号添加好友的 微信昵称。好友性别 添加时间
    // static getCloudMobileFriend(){
    //     return [Vars.NICKNAME(),Vars.GENDER(),Vars.DATE()]
    // }
    // static getBoostMsgVars() {
    //     return [Vars.BOOST_NAME()]
    // }

    static getRepeatScanMsgExample() {
        return '您已经参加了本次活动，快去把海报分享给好友吧TEMP_MXD_ENTER';
    }

    static getRepeatScanMsgVars() {
        let vars = [Vars.LINK(), Vars.RANK(), Vars.SPROGRAM()]
        return vars;
    }

    static getCompleteTaskMsgExample() {
        return '您好！您的好友#NICKNAME#支持你了！TEMP_MXD_ENTER您已获得#COMPLETED_TASK_NUM#个好友的支持TEMP_MXD_ENTER恭喜您完成任务！TEMP_MXD_ENTERTEMP_MXD_ENTER'
    }

    static newGetCompleteTaskMsgVars(){
        return [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME()]
    }

    static getCompleteTaskMsgVars(exts) {
        let vars = [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.SPROGRAM(),Vars.STOCKSURPLUS(), Vars.TIME()];
        if (exts) {
            if (exts.hasForm) {
                vars.push(Vars.FORM_LINK());
            }
            if (exts.hasRedeem) {
                vars.push(Vars.REDEEMCODE());
            }
            if (exts.hasRedeem2) {
                vars.push(Vars.REDEEMCODE2());
            }
            if (exts.hasRedeem3) {
                vars.push(Vars.REDEEMCODE3());
            }
        }
        return vars;
    }

    static getCompleteTaskMsgVarsWithForm() {
        return [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.FORM_LINK()];
    }

    static getCompleteTask2MsgExample() {
        return '您好！您的好友#NICKNAME#支持你了！TEMP_MXD_ENTER您已获得#COMPLETED_TASK_NUM#个好友的支持TEMP_MXD_ENTER恭喜您完成二阶任务！TEMP_MXD_ENTERTEMP_MXD_ENTER'
    }

    static getCompleteTask2MsgVars(exts) {
        let vars = [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME(), Vars.STOCKSURPLUS(), Vars.STOCKSURPLUS2(), Vars.STOCKSURPLUS3(),];
        if (exts) {
            if (exts.hasForm) {
                vars.push(Vars.FORM_LINK2());
            }
            if (exts.hasRedeem) {
                vars.push(Vars.REDEEMCODE());
            }
            if (exts.hasRedeem2) {
                vars.push(Vars.REDEEMCODE2());
            }
            if (exts.hasRedeem3) {
                vars.push(Vars.REDEEMCODE3());
            }
        }
        return vars;
    }

    static getCorpCompleteTask2MsgVars(exts) {
        let vars = [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME(), Vars.STOCKSURPLUS(), Vars.STOCKSURPLUS2(), Vars.STOCKSURPLUS3(),];
        if (exts) {
            if (exts.hasForm) {
                vars.push(Vars.FORM_LINK());
            }
            if (exts.hasRedeem) {
                vars.push(Vars.REDEEMCODE());
            }
            if (exts.hasRedeem2) {
                vars.push(Vars.REDEEMCODE2());
            }
            if (exts.hasRedeem3) {
                vars.push(Vars.REDEEMCODE3());
            }
        }
        return vars;
    }

    static getCompleteTask3MsgExample() {
        return '您好！您的好友#NICKNAME#支持你了！TEMP_MXD_ENTER您已获得#COMPLETED_TASK_NUM#个好友的支持TEMP_MXD_ENTER恭喜您完成三阶任务！TEMP_MXD_ENTERTEMP_MXD_ENTER'
    }

    static getCompleteTask3MsgVars(exts) {
        let vars = [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.FROM_NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME(), Vars.STOCKSURPLUS(), Vars.STOCKSURPLUS2(), Vars.STOCKSURPLUS3(),];
        if (exts) {
            if (exts.hasForm) {
                vars.push(Vars.FORM_LINK3());
            }
            if (exts.hasRedeem) {
                vars.push(Vars.REDEEMCODE());
            }
            if (exts.hasRedeem2) {
                vars.push(Vars.REDEEMCODE2());
            }
            if (exts.hasRedeem3) {
                vars.push(Vars.REDEEMCODE3());
            }
        }
        return vars;
    }

    static getCorpCompleteTask3MsgVars(exts) {
        let vars = [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.SPROGRAM(), Vars.TIME(), Vars.STOCKSURPLUS(), Vars.STOCKSURPLUS2(), Vars.STOCKSURPLUS3(),];
        if (exts) {
            if (exts.hasForm) {
                vars.push(Vars.FORM_LINK());
            }
            if (exts.hasRedeem) {
                vars.push(Vars.REDEEMCODE());
            }
            if (exts.hasRedeem2) {
                vars.push(Vars.REDEEMCODE2());
            }
            if (exts.hasRedeem3) {
                vars.push(Vars.REDEEMCODE3());
            }
        }
        return vars;
    }

    static getNmactMsgExample() {
        return '任务已完成！您的好友#NICKNAME#又支持你了TEMP_MXD_ENTER人气值+1TEMP_MXD_ENTER目前已有#COMPLETED_TASK_NUM#人支持你！'
    }

    static getNmactMsgVars(exts) {
        let vars = [Vars.LINK(), Vars.RANK(), Vars.NICKNAME(), Vars.COMPLETED_TASK_NUM(), Vars.SPROGRAM()];
        return vars;
    }

    static getActivityEndMsgExample() {
        return '本次活动已结束，更多精彩活动敬请关注'
    }

    static getActivityEndMsgVars(exts) {
        let vars = [Vars.NICKNAME(), Vars.LINK(), Vars.RANK(), Vars.SPROGRAM()];
        return vars;
    }

    static getHelpFailMsgExample() {
        return '本次活动已结束，更多精彩活动敬请关注'
    }


    static addFirendMsg() {
        return '你的好友已参与次活动，快提醒他添加客服小助手，完成助力吧'
    }

    static getHelpFailMsgExampleVars(exts) {
        let vars = [Vars.NICKNAME(), Vars.LINK(), Vars.RANK(), Vars.SPROGRAM()];
        if (exts) {
            if (exts.hasForm) {
                vars.push(Vars.FORM_LINK());
            }
        }
        return vars;
    }

    static getAddFirendMsgVars() {
        let vars = [Vars.NICKNAME(), Vars.LINK(), Vars.RANK(), Vars.SPROGRAM()];
        return vars;
    }

    /**
     * 根据选择的库存，生成相应的自动结束和库存相关的解释
     * @param selectStock
     */
    static getStockInCloseDes(selectStock) {
        if (selectStock && selectStock.length == 0) {
            return '';
        } else {
            selectStock.sort();
            let d = '';
            for (let i = 0; i < selectStock.length; i++) {
                if (selectStock[i] == 1) {
                    //一阶任务
                    d += '、一阶库存';
                }
                if (selectStock[i] == 2) {
                    d += '、二阶库存';
                } else if (selectStock[i] == 3) {
                    d += '、三阶库存';
                }
            }
            if (selectStock.length > 1) {
                return '当' + d.substring(1) + '同时为0时，自动结束任务';
            } else {
                return '当' + d.substring(1) + '为0时，自动结束任务';
            }
        }
    }

    static initMxdPanel() {
        let height = document.body.clientHeight - 184;
        $(".mxd-panel").css({'min-height': height + 'px', "margin-bottom": '62px'});
        window.onresize = function () {
            let height = document.body.clientHeight - 184;
            $(".mxd-panel").css({'min-height': height + 'px', "margin-bottom": '62px'});
        }
    }

    static transformDATA(msg) {
        let re = new RegExp("TEMP_MXD_ENTER", "g");
        msg = msg.replace(re, '<br/>');
        re = new RegExp("#NICKNAME#", "g");
        msg = msg.replace(re, NICKNAME_ITEM);
        re = new RegExp("#COMPLETED_TASK_NUM#", "g");
        msg = msg.replace(re, COMPLETED_TASK_NUM_ITEM);
        re = new RegExp("#UNCOMPLETED_TASK_NUM#", "g");
        msg = msg.replace(re, UNCOMPLETED_TASK_NUM_ITEM);
        re = new RegExp("#TOTAL_SUPPORT#", "g");
        msg = msg.replace(re, TOTAL_SUPPORT_ITEM);
        re = new RegExp("#STOCKSURPLUS#", "g");
        msg = msg.replace(re, STOCKSURPLUS_ITEM);
        re = new RegExp("#STOCKSURPLUS2#", "g");
        msg = msg.replace(re, STOCKSURPLUS_ITEM2);
        re = new RegExp("#STOCKSURPLUS3#", "g");
        msg = msg.replace(re, STOCKSURPLUS_ITEM3);
        re = new RegExp("#INVITATION_CODE#", "g");
        msg = msg.replace(re, INVITATION_CODE_ITEM);
        re = new RegExp("#TIME#", "g");
        msg = msg.replace(re, TIME_ITEM);
        re = new RegExp("#REDEEMCODE#", "g");
        msg = msg.replace(re, REDEEMCODE_ITEM);
        re = new RegExp("#REDEEMCODE_NOTTP#", "g");
        msg = msg.replace(re, REDEEMCODE_NOTTP_ITEM);
        re = new RegExp("#REDEEMCODE2#", "g");
        msg = msg.replace(re, REDEEMCODE_ITEM2);
        re = new RegExp("#REDEEMCODE3#", "g");
        msg = msg.replace(re, REDEEMCODE_ITEM3);
        re = new RegExp("#GOODS_NAME#", "g");
        msg = msg.replace(re, GOODS_NAME_ITEM);
        re = new RegExp("#DATETIME#", "g");
        msg = msg.replace(re, DATETIME_ITEM);
        re = new RegExp("#GOODS_AMOUNT#", "g");
        msg = msg.replace(re, GOODS_AMOUNT_ITEM);
        re = new RegExp("#GROUP_NUM#", "g");
        msg = msg.replace(re, GROUP_NUM_ITEM);
        re = new RegExp("#GROUP_LIMITEDTIME#", "g");
        msg = msg.replace(re, GROUP_LIMITEDTIME_ITEM);
        re = new RegExp("#GROUP_ENDDATE#", "g");
        msg = msg.replace(re, GROUP_ENDDATE_ITEM);
        re = new RegExp("#GROUP_BEGINDATE#", "g");
        msg = msg.replace(re, GROUP_BEGINDATE_ITEM);
        re = new RegExp("#FROM_NICKNAME#", "g");
        msg = msg.replace(re, FROM_NICKNAME_ITEM);
        re = new RegExp("#GROUP_PART_NUM#", "g");
        msg = msg.replace(re, GROUP_PART_NUM_ITEM);
        re = new RegExp("#GROUP_CREATER#", "g");
        msg = msg.replace(re, GROUP_CREATER_ITEM);
        re = new RegExp("#RETURN_AMOUNT#", "g");
        msg = msg.replace(re, RETURN_AMOUNT_ITEM);

        re = new RegExp("#TALLIESDESC#", "g");
        msg = msg.replace(re, TALLIESDESC_ITEM);

        re = new RegExp("#BOOST_NAME#", "g");
        msg = msg.replace(re, BOOST_NAME_ITEM);
        re = new RegExp("#GIFTBAG_NAME#", "g");
        msg = msg.replace(re, GIFTBAG_NAME_ITEM);
        re = new RegExp("#WXW_ACCOUNT_NAME#", "g");
        msg = msg.replace(re, WXW_ACCOUNT_NAME_ITEM);
        re = new RegExp("#ADD_TIME#", "g");
        msg = msg.replace(re, ADD_TIME_ITEM);
        re = new RegExp("#GENDER#", "g");
        msg = msg.replace(re, GENDER_ITEM);
        return msg;
    }
}

export default TaskposterUtil